import { render, staticRenderFns } from "./UserPageServerError.vue?vue&type=template&id=2d4f7444&scoped=true"
import script from "./UserPageServerError.vue?vue&type=script&lang=js"
export * from "./UserPageServerError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f7444",
  null
  
)

export default component.exports